const indexItems = [
  { title: '明星恋情', count: '3.2k 讨论', icon: 'ri-heart-line', color: 'primary' },
  { title: '综艺爆料', count: '2.8k 讨论', icon: 'ri-tv-line', color: 'accent' },
  { title: '影视资讯', count: '4.1k 讨论', icon: 'ri-film-line', color: 'secondary' },
  { title: '直播翻车', count: '1.9k 讨论', icon: 'ri-live-line', color: 'primary' },
  { title: '品牌代言', count: '2.5k 讨论', icon: 'ri-vip-crown-line', color: 'accent' },
  { title: '音乐八卦', count: '1.6k 讨论', icon: 'ri-music-line', color: 'secondary' },
  { title: '网红动态', count: '3.5k 讨论', icon: 'ri-user-star-line', color: 'primary' },
  { title: '年度盘点', count: '2.2k 讨论', icon: 'ri-calendar-check-line', color: 'accent' },
  { title: '独家揭秘', count: '4.8k 讨论', icon: 'ri-key-2-line', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; text: string; bgHover: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600', bgHover: 'hover:bg-primary-100/70' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600', bgHover: 'hover:bg-accent-100/70' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600', bgHover: 'hover:bg-secondary-100/70' },
};

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            主题索引
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, i) => {
            const c = colorMap[item.color];
            return (
              <a
                key={i}
                href="#index"
                className={`flex items-center gap-3 p-4 rounded-xl border border-background-200/60 bg-background-50 ${c.bgHover} transition-colors cursor-pointer group`}
              >
                <div className={`w-10 h-10 rounded-lg ${c.bg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${item.icon} ${c.text} text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <span className="block text-sm font-semibold text-foreground-800 group-hover:text-foreground-950 truncate whitespace-nowrap">
                    {item.title}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}